/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Ideon's address confidence captured when the provider was selected
 */
export enum AddressConfidence {
  high = 'high',
  medium = 'medium',
  low = 'low',
}
